import script from "./EstimationSettingsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./EstimationSettingsPage.vue?vue&type=script&setup=true&lang=ts"

import "./EstimationSettingsPage.vue?vue&type=style&index=0&id=384adfb9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-384adfb9"]])

export default __exports__